import React from "react";
import LOActivities from "../lo/LOActivities";
import BCError from "../BCError";

const Activities = ({ ...props }) => {
  return (
    <React.Fragment>
      {props.user.portal === "Loan Officer" ? <LOActivities
        isGreaterThanMobile={props.isGreaterThanMobile}
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar} 
        isMessage={props.isMessage}
        setIsMessage={props.setIsMessage}
        errorResponse={props.errorResponse}
        setErrorResponse={props.setErrorResponse}
      /> : <BCError 
        isGreaterThanTablet={props.isGreaterThanTablet}
        isSidebar={props.isSidebar}
      />}
    </React.Fragment>
  );
};

export default Activities;